// lib/NavigationContext.tsx
"use client";

import { createContext, useContext, useEffect, useRef, ReactNode } from "react";

import { usePathname, useRouter } from "@/i18n/routing";

interface NavigationContextType {
  previousPath: string | null;
  goBackOrHome: () => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export function NavigationProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const previousPath = useRef<string | null>(null);
  const router = useRouter();

  // 경로 변경 시 이전 경로 저장
  useEffect(() => {
    return () => {
      previousPath.current = pathname; // 현재 경로를 이전 경로로 저장
    };
  }, [pathname]);

  const goBackOrHome = () => {
    if (previousPath.current && previousPath.current.startsWith("/")) {
      router.back(); // 내부 경로면 뒤로 가기
    } else {
      router.push("/"); // 외부 출처거나 이전 경로 없으면 홈으로
    }
  };

  return (
    <NavigationContext.Provider value={{ previousPath: previousPath.current, goBackOrHome }}>
      {children}
    </NavigationContext.Provider>
  );
}

export function useD3Navigation() {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
}
